// extracted by mini-css-extract-plugin
module.exports = {"image":"_2r9Zh0W"};